/* eslint-disable react/no-array-index-key */
/* eslint-disable consistent-return */
import React, { useRef, useState, useEffect } from 'react';
import Image from 'next/image';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import ArrowRight from '../../../public/assets/white-next.svg';
import GreyNext from '../../../public/assets/grey-next.svg';
import Play from '../../../public/assets/play.png';
import VideoPopup from '../shared/VideoPopup';

export default function CarouselSection({
  title = '', subtitle = '', data = [], type,
}) {
  const scrollRef = useRef(null);
  const router = useRouter();
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentVideoUrl, setCurrentVideoUrl] = useState(null);

  const updateScrollButtons = () => {
    if (!scrollRef.current) return;
    const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
    setCanScrollLeft(scrollLeft > 0);
    setCanScrollRight(scrollLeft + clientWidth < scrollWidth);
  };

  const scroll = (direction) => {
    if (scrollRef.current) {
      const cardWidth = (scrollRef.current.firstChild?.offsetWidth ?? 429) + 25;
      const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
      const itemsPerScroll = isMobile ? 1 : 3;
      const scrollAmount = cardWidth * itemsPerScroll;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  const openModal = (item) => {
    if (!item?.videoUrl) return;
    setCurrentVideoUrl(item.videoUrl);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentVideoUrl(null);
  };

  useEffect(() => {
    updateScrollButtons();
    const container = scrollRef.current;
    if (!container) return;

    container.addEventListener('scroll', updateScrollButtons);
    window.addEventListener('resize', updateScrollButtons);

    return () => {
      container.removeEventListener('scroll', updateScrollButtons);
      window.removeEventListener('resize', updateScrollButtons);
    };
  }, []);

  useEffect(() => {
    updateScrollButtons();
    const rAF = requestAnimationFrame(() => updateScrollButtons());
    const t = setTimeout(() => updateScrollButtons(), 50);
    return () => {
      cancelAnimationFrame(rAF);
      clearTimeout(t);
    };
  }, [data]);

  return (
    <div className="w-full flex flex-col items-center mt-8">
      {isModalOpen && (
        <VideoPopup videoUrl={currentVideoUrl} onClose={closeModal} />
      )}
      {/* <div className="w-full py-4 flex flex-col px-5 md:px-[52px]">
        <div className="flex items-center">
          <div className="bg-[#ff5761] w-1.5 h-8 mt-0.5" />
          <h3 className="text-[22px]  font-medium text-black m-3">
            {title}
          </h3>
        </div>
        {subtitle && (
        <p className="text-[28px]  font-semibold text-black">
          {subtitle}
        </p>
        )}
      </div> */}
      {
        (title || subtitle)
        && (
        <div className="w-full flex flex-col items-center text-center mb-3">
          {title && <div dangerouslySetInnerHTML={{ __html: title }} />}
          {subtitle && <div dangerouslySetInnerHTML={{ __html: subtitle }} />}
        </div>
        )
      }

      {/* Carousel */}
      <div className="relative w-full px-0 md:px-[52px]">
        <div
          ref={scrollRef}
          className="flex overflow-x-auto scrollbar-hide gap-3 sm:gap-6 scroll-smooth snap-x md:snap-none"
        >
          {data.map((item, index) => (
            <div
              key={index}
              className="shrink-0 w-full md:w-[calc((100%-48px)/3)] md:max-w-[calc((100%-48px)/3)] bg-white flex flex-col space-y-4 md:pt-3 md:pb-1 px-4 py-1 snap-center md:snap-start rounded-md"
              onClick={() => type !== 'video' && item?.slug && router.push(`/course/${item?.slug}`)}
            >
              <div className="relative w-full h-[194px] overflow-hidden rounded-md">
                <Image
                  src={item?.thumbnailUrl || item?.listCardImage}
                  alt={item?.title || item?.name}
                  fill
                  className="object-cover"
                  onLoad={updateScrollButtons}
                />
                {type === 'video' && (
                  <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                    <button
                      type="button"
                      onClick={() => openModal(item)}
                      className="p-3 rounded-full bg-white"
                    >
                      <Image src={Play} alt="Play" width={16} height={16} />
                    </button>
                  </div>
                )}
              </div>

              {/* <div className="px-4 py-3 flex flex-col gap-2">
                <p className="text-[16px] font-semibold text-[#333] line-clamp-2">
                  {item?.title || item?.name}
                </p>
                {item.duration && (
                  <p className="text-[14px] text-[#333]">
                    <span className="font-bold">Course Duration: </span>
                    {item?.duration}
                  </p>
                )}
              </div> */}
              <p className="text-[18px] font-bold text-[#333] line-clamp-2">
                {item?.title || item?.name}
              </p>
            </div>
          ))}
        </div>

        {data.length > 3 && (
          <>
            <button
              type="button"
              onClick={() => scroll('left')}
              disabled={!canScrollLeft}
              className={`absolute left-4 sm:left-8 top-1/2 -translate-y-1/2 -ml-4 sm:-ml-2 p-3 hidden md:flex rounded-md shadow 
                ${canScrollLeft ? 'bg-[#1562af]' : 'bg-gray-200 cursor-not-allowed'}`}
            >
              <Image
                src={canScrollLeft ? ArrowRight : GreyNext}
                alt="Left Arrow"
                className="w-4 h-4 rotate-180"
              />
            </button>

            <button
              type="button"
              onClick={() => scroll('right')}
              disabled={!canScrollRight}
              className={`absolute right-4 sm:right-8 top-1/2 -translate-y-1/2 -mr-4 sm:-mr-2 p-3 hidden md:flex rounded-md shadow 
                ${canScrollRight ? 'bg-[#1562af]' : 'bg-gray-200 cursor-not-allowed'}`}
            >
              <Image
                src={canScrollRight ? ArrowRight : GreyNext}
                alt="Right Arrow"
                className="w-4 h-4"
              />
            </button>
          </>
        )}

        {data.length > 1 && (
          <>
            <button
              type="button"
              onClick={() => scroll('left')}
              disabled={!canScrollLeft}
              className={`absolute left-2 top-1/2 -translate-y-1/2 p-3 md:hidden rounded-md shadow 
                ${canScrollLeft ? 'bg-[#1562af]' : 'bg-gray-200 cursor-not-allowed'}`}
            >
              <Image
                src={canScrollLeft ? ArrowRight : GreyNext}
                alt="Left Arrow"
                className="w-4 h-4 rotate-180"
              />
            </button>

            <button
              type="button"
              onClick={() => scroll('right')}
              disabled={!canScrollRight}
              className={`absolute right-2 top-1/2 -translate-y-1/2 p-3 md:hidden rounded-md shadow 
                ${canScrollRight ? 'bg-[#1562af]' : 'bg-gray-200 cursor-not-allowed'}`}
            >
              <Image
                src={canScrollRight ? ArrowRight : GreyNext}
                alt="Right Arrow"
                className="w-4 h-4"
              />
            </button>
          </>
        )}
      </div>
    </div>
  );
}

CarouselSection.propTypes = {
  data: PropTypes.array,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  type: PropTypes.string,
};
